<template>
    <div>
        <p>Copyright © 2026 -<router-link to="/fnx">--</router-link>- A. N. Radcliffe</p>
    </div>
</template>

<style scoped>

</style>
